<template>
  <div class="my-6">
    <!-- commented out cause it is not working yet -->
    <!-- <div class="flex items-center mb-4 justify-between">
      <h3 class="text-root-2 font-semibold">Transactions</h3>
      <div class="md:flex items-center gap-x-3">
        <div
          class="flex items-center gap-x-1 border shadow-sm bg-root-3 border-root-3 text-root-2 px-2.5 py-3 md:mb-0 mb-2.5 rounded-md cursor-pointer"
          @click="showDialog('showTableFilter')"
        >
          <filter-icon />
          <p class="text-black-2 text-sm px-2 font-normal">Filter</p>
          <arrow-down-icon />
        </div>
      </div>
    </div> -->
    <div>
      <div class="mt-6" v-if="isLoading" test-id="isLoading">
        <spinner />
      </div>
      <div
        class="table-wrapper w-full overflow-x-auto"
        v-else-if="!noTransactions"
      >
        <el-table
          class="relative cursor-pointer font-normal text-root-2 text-xs lg:text-sm"
          index
          :data="tableData"
          style="width: 100%"
          max-height="500"
          @row-click="showCustomerDetails"
        >
          <el-table-column class="w-full" :width="240">
            <template slot="header">
              <div
                class="flex items-center py-2 px-2 lg:px-5 font-semibold"
                @click="sortHandler"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm mr-2"
                >
                  Customers
                </p>
                <el-tooltip content="Sort" placement="top" effect="light">
                  <sort-icon :sortDirection="sortDirection" />
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              <div
                class="px-2 lg:px-5 pl-2 flex items-center font-light text-xs md:text-sm"
              >
                <span>
                  <payment-icon />
                </span>
                <p class="pl-2">
                  {{
                    (scope.row.customer.firstName ||
                      scope.row.customer.first_name) +
                    ' ' +
                    (scope.row.customer.lastName ||
                      scope.row.customer.last_name)
                  }}
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column class="w-full" :width="columnWidth" align="center">
            <template slot="header">
              <div
                class="flex items-center py-2 px-2 lg:px-5 font-semibold"
                @click="sortHandler"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm mr-2"
                >
                  Amount
                </p>
                <el-tooltip content="Sort" placement="top" effect="light">
                  <sort-icon :sortDirection="sortDirection" />
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="font-bold flex items-center gap-x-1 px-2 lg:px-5">
                <span class="font-semibold text-xs md:text-sm capitalize"
                  >{{ scope.row.amount.symbol }}
                  {{ scope.row.amount.amount }}</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column class="w-full" :width="columnWidth">
            <template slot="header">
              <div
                class="flex items-center py-2 px-2 lg:px-5 font-semibold"
                @click="sortHandler"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm mr-2"
                >
                  Payment Method
                </p>
                <el-tooltip content="Sort" placement="top" effect="light">
                  <sort-icon :sortDirection="sortDirection" />
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="px-2 lg:px-5 font-light text-xs md:text-sm">
                {{ formatServerName(scope.row.method) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column class="w-full" :width="columnWidth" align="center">
            <template slot="header">
              <div
                class="flex items-center py-2 px-2 lg:px-5 font-semibold"
                @click="sortHandler"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm mr-2"
                >
                  Status
                </p>
                <el-tooltip content="Sort" placement="top" effect="light">
                  <sort-icon :sortDirection="sortDirection" />
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="flex items-center px-2 lg:px-5">
                <div
                  class="text-xs md:text-sm capitalize py-2 px-3 rounded-xl flex items-center justify-center shadow-sm"
                  :class="statusClass(scope.row.status)"
                >
                  {{ scope.row.status }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column class="w-full" width="200">
            <template slot="header">
              <div
                class="flex items-center py-2 font-semibold"
                @click="sortHandler"
              >
                <p
                  style="word-break: normal"
                  class="text-root-2 text-xs lg:text-sm mr-2"
                >
                  Date Created
                </p>
                <el-tooltip content="Sort" placement="top" effect="light">
                  <sort-icon :sortDirection="sortDirection" />
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="font-normal text-xs flex">
                <el-tooltip
                  :content="tooltipDateContent(scope.row.createdAt)"
                  placement="top"
                  effect="light"
                >
                  <span>{{ parseRelativeTime(scope.row) }} </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column class="w-full" width="50" align="center">
            <template slot-scope>
              <div class="flex items-center gap-x-3">
                <div class="ml-auto">
                  <arrow-right-icon />
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <transaction-empty-state
        test-id="emptyState"
        use="receive-payment"
        v-else
      >
        <h3 class="font-semibold text-root-2">No Transaction</h3>
        <p
          class="font-light text-root-4 text-xs flex items-center justify-center mt-2"
        >
          <span class="w-3/4 text-center"
            >Your payment link transactions will show up here</span
          >
        </p>
      </transaction-empty-state>
      <div class="p-6 grid grid-cols-1 md:justify-items-end">
        <!--Pagination-->
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="transactionsPage.size"
          @next-click="next"
          @prev-click="previous"
          background
          layout="prev, pager, next"
          :total="transactionsPage.totalCount"
        >
        </el-pagination>
        <!-- dialogs -->
        <filter-dialog
          v-if="showTableFilter"
          :showDialog="showTableFilter"
          @filterParams="searchFilterParams"
          @closeDialog="closeDialog('showTableFilter')"
        />
        <!-- drawer -->
        <customer-details-drawer
          v-if="showCustomerDetailsDrawer"
          :showDrawer="showCustomerDetailsDrawer"
          @closeDrawer="closeDrawer"
          :currentCustomer="currentCustomer"
        />
      </div>
    </div>
  </div>
</template>

<script>
import statusClass from '@/mixins/global.js'
import getPaymentLinkTransactions from '@/mixins/paymentLink.js'
import breakpoints from '@/utils/breakpoints.js'
import tooltipDateContent from '@/mixins/app.js'
import {
  FormatServerName,
  DaysAgo,
  ParseMoneyAll,
  ParseRelativeTime
} from '@/utils/helpers.js'

export default {
  mixins: [statusClass, getPaymentLinkTransactions, tooltipDateContent],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    isPaginate: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
    loading: { type: Boolean, default: false }
  },
  components: {
    ArrowRightIcon: () => import('@/assets/v2/icons/ArrowRightIcon.vue'),
    SortIcon: () => import('@/assets/v2/icons/SortIcon.vue'),
    TransactionEmptyState: () =>
      import('@/components/empty-states/TransactionEmptyState.vue'),
    FilterDialog: () =>
      import('@/components/v2/paymentLink/dialogs/FilterDialog.vue'),
    PaymentIcon: () => import('@/assets/v2/icons/PaymentIcon.vue'),
    Spinner: () => import('@/components/v2/app/Spinner.vue'),
    CustomerDetailsDrawer: () =>
      import('@/components/v2/paymentLink/drawer/CustomerDetailsDrawer.vue')
  },
  data () {
    return {
      payload: {
        page: 1,
        size: 5,
        status: '',
        type: '',
        from: '',
        to: '',
        sort_direction_desc: true,
        sort_by: 'created_at'
      },
      currentCustomer: {},
      showTableFilter: false,
      transactionDetails: {},
      mode: '',
      sortDirection: 'up',
      isLoading: this.loading,
      search: '',
      showCustomerDetailsDrawer: false
    }
  },
  methods: {
    parseRelativeTime (row) {
      const timeToPick =
        row.status === 'completed' ? row.completedAt : row.createdAt
      return ParseRelativeTime(timeToPick)
    },
    closeDrawer () {
      this.showCustomerDetailsDrawer = false
    },
    showCustomerDetails (row) {
      this.currentCustomer = row.customer
      this.showCustomerDetailsDrawer = true
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    sortHandler () {
      this.sortDirection = this.sortDirection === 'up' ? 'down' : 'up'
      this.$emit('sort')
    },
    daysAgo (date) {
      return DaysAgo(date)
    },
    searchFilterParams (filterParams) {
      this.applyDateFilter(filterParams)
      this.getPaymentLinks()
    },
    formatServerName (val) {
      return FormatServerName(val)
    },
    next () {
      this.payload.page++
      this.getPaymentLinks()
    },
    previous () {
      this.payload.page--
      this.getPaymentLinks()
    },
    handleCurrentChange (val) {
      this.payload.page = val
      this.getPaymentLinks()
    },
    closeDialog (dialog) {
      this[dialog] = false
    },
    showDialog (dialog, mode, details) {
      if (mode === 'edit') {
        this.$store.dispatch(
          'paymentLink/setCurrentPaymentLinkDetails',
          details
        )
      }
      this.mode = mode
      this[dialog] = true
    },
    goToCreatePaymentLink () {
      this.$router.push({
        path: '/payment-link',
        query: {
          mode: 'create'
        }
      })
    },
    paymentLinkCreated (view) {
      this.mode = view
      this.showPaymentLinkCreated = true
    },
    paymentLinkDetails (title, id) {
      this.$store.dispatch('paymentLink/setCurrentPaymentLinkId', id)
      this.$router.push(`/payment-link-details/${id}`)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Payment Link Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    previewLink (url) {
      window.open(url)
    }
  },
  computed: {
    noTransactions () {
      return !this.currentPaymentLinkTransactions.length && !this.isLoading
    },
    transactionsPage () {
      return this.$store.state.paymentLink.paymentLinkTransactions.page
    },
    currentPaymentLinkTransactions () {
      return this.$store.state.paymentLink.paymentLinkTransactions.items
    },
    currentPaymentLinkId () {
      return this.$store.state.paymentLink.currentPaymentLinkId
    },
    columnWidth () {
      return breakpoints.lgAndUp ? 'auto' : breakpoints.mdAndUp ? '220' : '170'
    }
  },
  async mounted () {
    await this.getPaymentLinkTransactions()
  }
}
</script>

<style scoped>
>>> .el-table {
  padding: 0;
  background: transparent;
  border-collapse: separate;
}
>>> .el-table table {
  border-spacing: 0 16px;
}

>>> .el-table th {
  border: none !important;
  background: #f7f7f7;
  padding: 0;
}

>>> .el-table tr {
  background: white;
  border-radius: 8px;
}
>>> .el-table tr:hover {
  cursor: pointer;
}
>>> .el-table td {
  border-bottom: none !important;
  background: white;
}

>>> .el-table td:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
>>> .el-table td:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

>>> .el-table::before {
  height: 0px;
}
>>> .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: white !important;
}
>>> li.number.active {
  background-color: var(--color-primary) !important;
  border: none !important;
  color: white !important;
  border-radius: 7.53065px !important;
}
>>> li.number {
  border: none !important;
  font-weight: 500;
  font-size: 12px;
  color: var(--text-2);
  background: transparent !important;
  /* color: var(--color-primary) !important ; */
}
>>> li.number:hover {
  border: 0.941331px solid var(--color-primary) !important;
  border-radius: 7.53065px !important;
  color: var(--text-2) !important;
}
>>> .el-input--prefix .el-input__inner {
  border: 1px solid var(--border-1);
  border-radius: 8px;
  background: var(--background-10);
}
>>> .el-table__empty-text {
  display: none;
  height: 0;
}
>>> .el-table__empty-block {
  height: 0 !important;
  min-height: 0;
}
>>> .el-tooltip__popper.is-dark,
>>> .el-tooltip__popper.is-light,
>>> .el-tooltip__popper {
  background: white !important;
}
>>> .el-tooltip__popper.is-light {
  background: white !important;
}
</style>
